import { gridClasses, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import { DateTime } from "luxon";
import React from "react";
import { padTime } from "../../util/dateTimeFormatter";
import { getTimeZoneFromSwaStation } from "../../util/timeZoneService";

export default function TemporaryAssignmentFormToolbar(props) {
  const date = DateTime.now().setZone(getTimeZoneFromSwaStation(props.station));
  const fileName = `STARS_Temp_Assignment_${padTime(date.month)}-${padTime(date.day)}-${date.year}_${padTime(
    date.hour
  )}${padTime(date.minute)}`;
  const columns = [
    "referenceNumber",
    "employeeName",
    "employeeID",
    "workgroup",
    "contact",
    "homeStation",
    "tempStation",
    "assignmentStartDate",
    "assignmentEndDate",
    "assignmentDateDonotMatch",
    "effectiveStartDate",
    "effectiveEndDate",
    "status",
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat",
    "createdBy",
    "createDate",
    "lastUpdatedDate",
  ];
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport
        csvOptions={{ fileName: fileName, fields: columns }}
        printOptions={{ disableToolbarButton: true }}
      />
    </GridToolbarContainer>
  );
}
